module.exports = __webpack_public_path__ + "img/shield-check.213bda68.svg";